var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSNavBarTop, HDSProfileMenu, } from "@here/hds-react-components/NavBar";
import { HDSListItem } from "@here/hds-react-components/List";
import { HDSTab, HDSTabBar } from "@here/hds-react-components/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { setIsMigrateMap, setIsUpdateOrder, setMapCollectionSelected, setSelectedTab, } from "../../store/reducers/appSlice";
import translations from "../../translations/resources/en-GB.json";
import { useHistory, useLocation } from "react-router-dom";
import { initLogOut } from "../../store/reducers/userSlice";
import Header from "./Header";
import { PORTAL_TABS } from "../../store/common/constants";
import { setDiscardAllAnnotations, setMomData, setShowJSMAPDiscardModal, } from "../../store/reducers/jsMapSlice";
import { setVenue } from "../../store/reducers/venueSlice";
import { TabConfigList } from "./constant";
import { showInternalToolsTab } from "./helper";
var HeaderComponent = function () {
    var dispatch = useDispatch();
    var history = useHistory();
    var pathname = useLocation().pathname;
    var selectedTab = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.selectedTab; });
    var user = useSelector(function (state) { return state.user.info; });
    var env = useSelector(function (state) { return state.app.environment; });
    var isNoMap = useSelector(function (state) { return state.app.isNoMap; });
    var isRealmSetup = useSelector(function (state) { return state.app.isRealmSetup; });
    var isLoaded = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isLoaded; });
    var userInfo = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.info; });
    var isAuthorizedForRealmSetup = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isAuthorizedForRealmSetup; });
    var annotationPresent = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.annotationPresent; });
    var style = {
        pointerEvents: "none",
    };
    var onSelectedTab = function (tab) {
        annotationPresent
            ? dispatch(setShowJSMAPDiscardModal(true))
            : (dispatch(setMapCollectionSelected(false)),
                dispatch(setMomData({ momData: null })),
                dispatch(setVenue(null)),
                dispatch(setIsMigrateMap(false)),
                dispatch(setIsUpdateOrder(false)),
                dispatch(setDiscardAllAnnotations(true)));
        dispatch(setSelectedTab(tab));
        if (pathname !== "/") {
            history.push({
                pathname: "/",
                search: window.location.search,
            });
        }
    };
    return (_jsx("div", __assign({ className: "header-container" }, { children: _jsxs(HDSNavBarTop, { children: [_jsx("div", __assign({ slot: "page-title" }, { children: "Indoor" })), _jsx(HDSTabBar, __assign({ slot: "tabs-menu", "data-cy": "head-bar" }, { children: Object.keys(TabConfigList).map(function (tab, index) {
                        var _a;
                        //in case there are no realm setup/no maps, Your indoor map tab should not be visible
                        if ((tab === "indoorMap" && !isLoaded) ||
                            (tab === "indoorMap" && isNoMap) ||
                            (tab === "indoorMap" && !isRealmSetup)) {
                            return _jsx("div", {}, "".concat(TabConfigList[tab].title, "-").concat(index));
                        }
                        if (tab === PORTAL_TABS.INTERNAL_TOOLS &&
                            showInternalToolsTab(isRealmSetup, isLoaded, user, isAuthorizedForRealmSetup)) {
                            return _jsx("div", {}, "".concat(TabConfigList[tab].title, "-").concat(index));
                        }
                        var cypressTabName = ((_a = TabConfigList[tab]) === null || _a === void 0 ? void 0 : _a.title)
                            ? "".concat(TabConfigList[tab].title).replace(/ /g, "-") + "-head-bar"
                            : "head-bar";
                        return (_jsx(HDSTab, __assign({ tabPanelId: "".concat(TabConfigList[tab].title, "-").concat(index), style: { margin: "10px" }, link: !!TabConfigList[tab].url, "external-link": !!TabConfigList[tab].url, selected: tab === selectedTab, onClick: function () { return onSelectedTab(tab); }, "data-cy": cypressTabName }, { children: TabConfigList[tab].url ? (_jsx("a", __assign({ href: TabConfigList[tab].url, target: "_blank", rel: "noreferrer" }, { children: TabConfigList[tab].title }))) : (TabConfigList[tab].title && TabConfigList[tab].title) }), "".concat(TabConfigList[tab].title, "-").concat(index)));
                    }) })), _jsx("div", __assign({ slot: "profile-menu", "data-cy": "user-profile" }, { children: _jsxs(HDSProfileMenu, __assign({ "data-test": "profile-menu", profileName: userInfo.name, profileEmail: userInfo.email }, { children: [_jsxs(HDSListItem, __assign({ style: style, "data-cy": "user-info" }, { children: [translations.data["venonboard.header.profileMenu.organization"], " ", userInfo.realm] })), _jsx(HDSListItem, __assign({ "data-test": "sign-out", icon: "sign-out", onClick: function () {
                                    history.push({
                                        pathname: "/",
                                        search: window.location.search,
                                    });
                                    dispatch(initLogOut());
                                }, "data-cy": "sign-out" }, { children: translations.data["venonboard.header.profileMenu.signOut"] }))] })) })), _jsx(Header, { user: user, env: env, logOut: function () {
                        dispatch(initLogOut());
                    } })] }) })));
};
export default HeaderComponent;
